"use client";
import { useEffect } from "react";

function Summary() {
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) return;

    const encodedToken = encodeURIComponent(token);

    window.open(
      `http://localhost:3000/public/recovery?token=${encodedToken}`,
      "_blank",
      "noopener,noreferrer"
    );
  }, []);

  return null;
}

export default Summary;
